import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

export var DEFAULT_BLOCKOPTIONS_VISIBILITY = {
  visibleMobile: true,
  visibleDesktop: true
}; //Below are the old default blockoptions, these are no longer provided from the CMS
//To bring them back, uncomment the DEFAULT_BLOCKOPTIONS array below

var BlockOptions_Colors_Inputs = [{
  inputType: "color",
  label: "Text Color",
  keyName: "colors_text",
  extraVals: ["auto"]
}, {
  inputType: "color",
  label: "Title Color",
  keyName: "colors_title",
  extraVals: ["auto"]
}, {
  inputType: "color",
  label: "Accent 1",
  keyName: "colors_accent1",
  extraVals: ["auto"]
}, {
  inputType: "color",
  label: "Accent 2",
  keyName: "colors_accent2",
  extraVals: ["auto"]
}, {
  inputType: "color",
  label: "Background Color",
  keyName: "colors_bg",
  extraVals: ["none"],
  extraLabels: ["None"]
}];
var BlockOptions_Spacing_Inputs = [{
  inputType: "slider",
  label: "Padding Top:",
  keyName: "spacing_paddingTop"
}, {
  inputType: "slider",
  label: "Padding Bottom:",
  keyName: "spacing_paddingBottom",
  min: -50
}, {
  inputType: "radio",
  label: "Overlap next block:",
  keyName: "spacing_border_type",
  labelArr: ["None", "Slanted left", "Slanted right"]
}, {
  inputType: "slider",
  label: "Border Size:",
  keyName: "spacing_border_size"
}];
var BlockOptions_Bg_Inputs = [{
  inputType: "conditionalRadio",
  label: "Background type",
  keyName: "bg_type",
  labelArr: ["None", "Solid color", "Image", "Video"],
  valueArr: ["none", "color", "image", "video"],
  childInputsArr: [[], [{
    inputType: "color",
    label: "Background Color",
    keyName: "colors_bg"
  }], [{
    inputType: "image",
    label: "Background Image",
    keyName: "bg_image"
  }, {
    inputType: "checkbox",
    label: "Repeat Background",
    keyName: "bg_repeat"
  }, {
    inputType: "radio",
    label: "Scroll FX",
    keyName: "bg_scrollFx",
    labelArr: ["None", "Zoom", "Fixed", "Parallax"],
    valueArr: ["", "zoom", "fixed", "parallax"]
  }], [{
    inputType: "video",
    keyName: "bg_video",
    label: "Background video"
  }]]
}];
export var DEFAULT_BLOCKOPTIONS_DEFAULTS = _objectSpread({
  colors_text: "auto",
  colors_title: "auto",
  colors_accent1: "auto",
  colors_accent2: "auto",
  colors_bg: "none",
  spacing_paddingTop: 0,
  spacing_paddingBottom: 0,
  bg_image: "",
  bg_repeat: false,
  bg_parallax: false,
  spacing_border_type: 0,
  spacing_border_size: 0
}, DEFAULT_BLOCKOPTIONS_VISIBILITY);
var DEFAULT_BLOCKOPTIONS = [
  /*
  {
    tag: "Colors",
    options: BlockOptions_Colors_Inputs,
  },
  {
    tag: "Spacing",
    options: BlockOptions_Spacing_Inputs,
  },
  {
    tag: "Background",
    options: BlockOptions_Bg_Inputs,
  },*/
];
export default DEFAULT_BLOCKOPTIONS;